import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-KM-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 32.89 29.77"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-KM-logo_svg__cls-1{fill:#c8102e}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M17.44 29.77h8.85l-4.45-4.09-4.4 4.09Zm-6.65-6.09 4.35-4.71-3.32-3.63L0 29.77h17.24l4.6-10.79-11.05 4.71ZM21.84 18.98 17.39 8.54l-3.43 4.19-1.74 2.15 9.62 4.09Zm0 0 4.65 10.79h.46l1.59-7.93-6.7-2.86Z",
      class: "svg-KM-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M32.89.05 31.3 8.03l-1.53 7.62-7.93 3.38 4.71-11.05-4.71 4.35-4.24-3.99 3.94-4.81 1.33-1.64C24 .2 26.35 0 26.35 0h6.55v.05Z",
      class: "svg-KM-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "KM-logo"}) } }